<template>
    <div id="fanfinalpage" class="container-fluid text-center">
        <Navigator></Navigator>
        <div class="row">
            <div class="col-12 my-5">
                <h1>Thank you for using Kalamaio.</h1>
            </div>
            <div id="picbox" class="col-12">
                <div id="photowrap" class="output" style="display:none">
                    <img id="photo" alt="Your selfie">
                </div>
                <div v-if="picture">
                    <b-button pill class="m-3 text-dark" @click="download">
                        Download</b-button>
                    <b-button pill class="m-3 text-dark" @click="share">
                        Share</b-button>
                </div>
            </div>
        </div>
        <div id="lowbar" class="row mt-5">
            <div class="col-12">
                <b-button variant="light" class="m-3" @click="shop">
                    Kalamaio Shop</b-button>
                <br>
                <router-link :to="{ name: 'Home'}">
                    <b-button variant="secondary" class="m-3">
                        Back Home</b-button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<style>
    #fanfinalpage {
        background: #06424d;
        color: white;
    }

    #photowrap img {
        border: 3px #ffc000 groove;
        object-fit: cover;
        overflow: hidden;
        border-radius: 20px;
        margin: auto;
        position: relative;
    }
    #lowbar {
        min-height: 5rem;
    }
</style>

<script>
import Navigator from '../../components/Navigator.vue';
import firebase from '../../firebase';

export default {
    data() {
        return {
            picture: null,
            meetingId: null
        };
    },
    computed: {
        filename() {
            return `Kalamemories-${this.meetingId}.png`;
        }
    },
    components: { Navigator },
    methods: {
        download() {
            const photo = document.getElementById('photo');
            const a = document.createElement('a');
            a.href = photo.src;
            a.target = '_blank';
            a.download = this.filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        share() {
            alert('Not yet available! For now you can download the image and share it with your friends!');
        },
        shop() {
            alert("Shop is closed now. But no worries, we're opening soooon!");
        }
    },
    mounted() {
        this.meetingId = this.$route.params.meetingId;
        firebase.meetingImages.child(this.meetingId)
            .getDownloadURL()
            .then((url) => {
                this.picture = url;
                const photowrap = document.getElementById('photowrap');
                photowrap.style.display = 'block';
                const photo = document.getElementById('photo');
                photo.setAttribute('src', this.picture);
            })
            .catch(() => {
                console.log('No pic mode');
            });
    }
};
</script>
